import React from 'react';
import { ServicePage } from './ServicePage';
import { getService } from '../data/services';
const service = getService('automation');
export function AutomationPage() {
  if (!service) return null;
  return <ServicePage service={service} data-id="element-164" data-mp="1ivzsbczijsb8" />;
}